import { syncAction } from 'lib/action';

export const toggleDocumentHotkeysModalAction = syncAction('UI/TOGGLE_DOCUMENT_HOTKEYS_MODAL');
export const toggleWorkspaceHotkeysModalAction = syncAction('UI/TOGGLE_WORKSPACE_HOTKEYS_MODAL');
export const toggleAFPanelAction = syncAction('UI/TOGGLE_APPROVAL_FLOW_PANEL');
export const setApprovalStampModeAction = syncAction('UI/SET_APPROVAL_STAMP_MODE');
export const setApprovalStampAction = syncAction('UI/SET_APPROVAL_STAMP_POSITION');
export const setUiWorkspaceContextMenuAction = syncAction('UI/SET_WORKSPACE_CONTEXT_MENU');
export const setUiSelectOpenAction = syncAction('UI/SET_SELECT_OPEN');
export const setUiDrawerOpenAction = syncAction('UI/SET_DRAWER_OPEN');
export const addUiDeferredToastAction = syncAction('UI/ADD_DEFERRED_TOAST');
export const clearUiDeferredToastsAction = syncAction('UI/RESET_DEFERRED_TOASTS');
